import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import HighlightsForm from './HighlightsForm';
import HighlightsReasons from '../HighlightsReasons/HighlightsReasons';
import './MarketHighlights.css';

const MarketHighlights = () => {
  return (
    <div className="highlights-page">
      {/* 1. Navbar */}
      <Navbar /> 
      
      {/* 2. Hero Section (Blue Gradient) */}
      <section className="highlights-hero">
        <div className="container highlights-content">
          <h1>Provenance Market Highlights</h1>
        </div>
      </section>

      {/* 3. NEW TEXT SECTION (Added this part) */}
      <section className="highlights-info">
        <div className="container">
          <p>
            These free email alerts keep you ahead of the rapidly changing energy and commodity 
            markets with the latest news and insight from Provenance, sent direct to your inbox.
          </p>
          <p>
            Our world-class team of market experts are regularly producing thought leadership 
            content across a wide range of markets.
          </p>
          <p>
            Sign-up today to receive industry-specific email updates to help you understand the 
            key drivers behind market trends and price movements. With the latest industry news, 
            market commentary, analytical insight, special features and key pricing indications, 
            Provenance Market Highlights keep you well informed.
          </p>
        </div>
      </section>

      <HighlightsForm />

      <HighlightsReasons />

      {/* 4. Footer */}
      <Footer />
    </div>
  );
};

export default MarketHighlights;